"use client";

import { CopyableContent } from "@/src/components/copyable-content";
import { getFormattedAddress } from "@/src/models/address";
import { Referral } from "@/src/models/documents/referral";
import { getPractitionerNameWithCredentials } from "@/src/models/practitioner";

interface ReferringProviderSectionProps {
  referral: Referral;
  title?: string;
}

export function ReferringProviderSection({
  referral,
  title = "Referring Provider Information:",
}: ReferringProviderSectionProps) {
  const referringProviderName = referral.referringProvider
    ? getPractitionerNameWithCredentials(referral.referringProvider)
    : "N/A";
  const referringProviderNPI = referral.referringProvider?.npiNumber || "N/A";
  const referringLocationAddress = referral.referringLocation?.address
    ? getFormattedAddress(referral.referringLocation.address) || "N/A"
    : "N/A";

  return (
    <div className="mb-4 my-2">
      <h3 className="font-semibold text-foreground my-2">{title}</h3>
      <div className="grid grid-cols-3">
        <div>
          <span className="font-medium">Name: </span>
          <CopyableContent text={referringProviderName} />
        </div>
        <div>
          <span className="font-medium">NPI: </span>
          <CopyableContent text={referringProviderNPI} />
        </div>
        <div>
          <span className="font-medium">Referring Location: </span>
          <CopyableContent text={referringLocationAddress} />
        </div>
      </div>
    </div>
  );
}
